import React from 'react'
import { Box, Text, Stack } from '@chakra-ui/react'
import { numberToDollars } from '../../utils/numberToCurrency'
import { useFormatNumber } from '../../utils/intlHelpers'
import { TaxWithholdingTypes, TaxWithholdingValueType } from '@Types'

export interface TransferDetailsPreviewProps {
  distributionReason?: string
  federalTaxWithholdingType?: TaxWithholdingTypes
  federalTaxWithholdingAmountRaw?: number
  stateTaxWithholdingType?: TaxWithholdingTypes
  stateTaxWithholdingAmountRaw?: number
  receivingInstitutionName?: string
}

const ModalDistributionDetailsPreview = ({
  distributionReason,
  federalTaxWithholdingType,
  federalTaxWithholdingAmountRaw = 0,
  stateTaxWithholdingType,
  stateTaxWithholdingAmountRaw = 0,
  receivingInstitutionName
}: TransferDetailsPreviewProps) => {
  const formatNumber = useFormatNumber()

  return (
    <Stack spacing={2}>
      <Text as='h3' textStyle='h3'>
        Distribution Details
      </Text>
      <Stack spacing={4}>
        <Stack direction='row' w='100%' spacing={4}>
          <Box data-testid='distributionReason'>
            <Text fontWeight='bold'>Distribution Reason</Text>
            <Text>{distributionReason}</Text>
          </Box>
        </Stack>
        {receivingInstitutionName && (
          <Box>
            <Text fontWeight='bold'>Receiving Institution Name</Text>
            <Text>{receivingInstitutionName}</Text>
          </Box>
        )}
        {federalTaxWithholdingType && (
          <Stack direction='row' w='100%' spacing={4}>
            <Box w='50%' data-testid='federalTaxWithholdingType'>
              <Text fontWeight='bold'>Federal Tax Withholding Type</Text>
              <Text>{federalTaxWithholdingType}</Text>
            </Box>
            <Box w='50%' data-testid='federalTaxWithholdingAmount'>
              <Text fontWeight='bold'>Federal Tax Withholding Amount</Text>
              <Text>
                {federalTaxWithholdingType === TaxWithholdingValueType.Fixed
                  ? numberToDollars(federalTaxWithholdingAmountRaw)
                  : `${formatNumber(federalTaxWithholdingAmountRaw)}%`}
              </Text>
            </Box>
          </Stack>
        )}
        {stateTaxWithholdingType && (
          <Stack direction='row' w='100%' spacing={4}>
            <Box w='50%' data-testid='stateTaxWithholdingType'>
              <Text fontWeight='bold'>State Tax Withholding Type</Text>
              <Text>{stateTaxWithholdingType}</Text>
            </Box>
            <Box w='50%' data-testid='stateTaxWithholdingAmount'>
              <Text fontWeight='bold'>State Tax Withholding Amount</Text>
              <Text>
                {stateTaxWithholdingType === TaxWithholdingValueType.Fixed
                  ? numberToDollars(stateTaxWithholdingAmountRaw)
                  : `${formatNumber(stateTaxWithholdingAmountRaw)}%`}
              </Text>
            </Box>
          </Stack>
        )}
      </Stack>
    </Stack>
  )
}

export default ModalDistributionDetailsPreview
